
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import {  HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { HomeComponent } from './components/home/home.component';
import { EnrollmentAgentComponent } from './components/enrollment-agent/enrollment-agent.component';
import { AvaamoComponent } from './components/student-support/avaamo/avaamo.component';
import { AzureComponent } from './components/student-support/azure/azure.component';
import { AppRoutingModule } from './app-routing.module';
import {  OKTA_CONFIG,   OktaAuthModule} from '@okta/okta-angular';
import { ToastrModule } from 'ngx-toastr';

import { AppComponent } from './app.component';
import oktaConfig from './app.config';
import { StudentAvaamoBotService } from './services/student-avaamo-bot.service';
import OktaAuth from '@okta/okta-auth-js';
import { ChatbotComponent } from './components/chatbot/chatbot.component';
import { LogoutCallbackComponent } from './components/logout-callback/logout-callback.component';
const oktaConfigDetails = new OktaAuth(oktaConfig.oidc);

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    EnrollmentAgentComponent,
    LogoutCallbackComponent,
    AvaamoComponent,
    AzureComponent,
    ChatbotComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    OktaAuthModule,
    ToastrModule.forRoot()
  ],
  providers: [
   {  provide:OKTA_CONFIG, useValue: {oktaAuth :oktaConfigDetails}
    },
    StudentAvaamoBotService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
